import _objectWithoutProperties from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
var __jsx = React.createElement;
import React from 'react';
var defaultValue = {
  removeBlock: function removeBlock() {
    return;
  },
  updateBlockData: function updateBlockData() {
    return;
  }
};
export var RichTextEditorMethodsContext = /*#__PURE__*/React.createContext(defaultValue);
export var RichTextEditorMethodsProvider = function RichTextEditorMethodsProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return __jsx(RichTextEditorMethodsContext.Provider, {
    value: props
  }, children);
};